import { Form } from "../Support/Form";
import { axios } from "../Support/axios";

export class Logs extends Form {

    constructor(data = {}) {
        super(data);


        this.ip_lookup = false;

        this.resetFilters();
    }

    resetFilters() {
        let self = this;

        return new Promise(resolve => {
            self.filters = {
                query: null,
                status: null,
                method: null,
            };

            resolve(true);
        });
    }

    getLogs(append = false) {
        let self = this;

        return new Promise((resolve, reject) => {
            let uri = '/api/log?page=' + self.page + '&type=' + self.type;

            if (this.filters) {
                uri = uri + '&q=' + this.filters.query + '&status=' + this.filters.status + '&method=' + this.filters.method;
            }

            axios.get(uri, self.data)
                .then(response => {
                    let result = response.data;

                    self.processIndexData(result, append);

                    resolve(true);
                })
                .catch(error => {

                    console.error(error);

                    self.setError(error);

                    reject(error);
                })
        });
    }

    selectLog(index) {
        let self = this;

        return new Promise(resolve => {

            self.selected = this.index_data.data[index];

            resolve(self.selected);
        });
    }

    ipLookup(ip) {
        let self = this;

        return new Promise(resolve => {

            axios.get('/api/lookup-ip/' +  ip)
                .then(response => {
                    self.ip_lookup = response.data;

                    resolve(self.ip_lookup);
                });

        });
    }

    closeIpLookup() {
        this.ip_lookup = false;
    }

}
